import React, { FC } from 'react'
import { InputComponent, InputProps } from 'LibNeo'
import { Validators } from 'Modules'
import { FieldNames } from 'Constants/FieldNames'
import { useBgDict } from 'Pages/ibro'

interface ComponentProps extends InputProps {
	fieldName: string
	lockedFields?: FieldNames[]
}

export const BgTextInput: FC<ComponentProps> = ({ lockedFields = [], ...props }) => {
	const { allowedSymbols } = useBgDict()

	return (
		<InputComponent
			{...props}
			fieldOptions={
				props.fieldOptions
					? {
							...props.fieldOptions,
							rules: lockedFields.includes(props.fieldName as FieldNames)
								? []
								: [
										allowedSymbols
											? {
													validator: Validators.checkInvalidCharacters({
														payload: {
															allowSymbols: allowedSymbols,
														},
													}),
											  }
											: {},
										...(props.fieldOptions?.rules ?? []),
								  ],
					  }
					: {}
			}
		/>
	)
}
